export default config => (state = config, action) => {

    return state;

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/config/config-reducer.ts